// components/SignUp.js
import { Box } from "@chakra-ui/react";

import Sidebar from "components/layouts/Sidebar";
import AgendaForm from "components/Form/AgendaForm";

const AddAgenda = () => {
  return (
    <Sidebar>
      <Box>
        <AgendaForm />
      </Box>
    </Sidebar>
  );
};

export default AddAgenda;
